

import { mapGetters } from "vuex";
export default {
  name: 'UserNav',
  data() {
    return {
      isDrawerOpen: false,
    };
  },
  computed: {
    ...mapGetters(["getUserProfile", "getUserInformation"]),
    name: {
      get() {
        return this.getUserInformation.user.name;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, name: value },
          },
        });
      },
    },
    email: {
      get() {
        return this.getUserInformation.user.email;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, email: value },
          },
        });
      },
    },
    phone_number: {
      get() {
        return this.getUserInformation.user.phone_number;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, phone_number: value },
          },
        });
      },
    },
    twitter_handle: {
      get() {
        return this.getUserInformation.user.twitter_handle;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, twitter_handle: value },
          },
        });
      },
    },
    facebook_handle: {
      get() {
        return this.getUserInformation.user.facebook_handle;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, facebook_handle: value },
          },
        });
      },
    },
    country: {
      get() {
        return this.getUserInformation.user.country;
      },
      set(value) {
        this.$store.commit("set", {
          type: "userInformation",
          data: {
            ...this.getUserInformation,
            user: { ...this.getUserInformation.user, country: value },
          },
        });
      },
    },
  },
  methods: {
    logout() {
      this.$store.commit("logOut");
    },
    async updateUser() {
      let id = this.getUserInformation.user.id;
      let res = await this.$store.dispatch("put", {
        endpoint: `/auth/profile/${id}/`,
        auth: true,
        payload: this.getUserInformation.user,
      });
      if (res.status == 200) {
        this.$store.commit("set", {
          type: "userInformation",
          data: res,
        });
      }
    },
  },
  async created() {
    let id = this.getUserInformation.user.id;
    let res = await this.$store.dispatch("get", {
      endpoint: `/auth/profile/${id}`,
      auth: true,
    });
    if (!!res) {
      this.$store.commit("set", {
        type: "userProfile",
        data: res,
      });
    }
  },
};
